export function isClient() {
  return typeof window !== 'undefined';
}

export function isServer() {
  return typeof window === 'undefined';
}

export function isProduction() {
  return process.env.NEXT_PUBLIC_ENV === 'production';
}

export function isDevelopment() {
  return process.env.NEXT_PUBLIC_ENV === 'development';
}

export function isTest() {
  return process.env.NEXT_PUBLIC_ENV === 'test';
}

export function getEnv() {
  if (process.env.NEXT_PUBLIC_ENV === 'staging') {
    return 'staging';
  }

  if (process.env.NEXT_PUBLIC_ENV === 'production') {
    return 'production';
  }

  if (process.env.NEXT_PUBLIC_ENV === 'development') {
    return 'development';
  }

  return 'unknown';
}
